import Vue from "vue";

//Vue.config.devtools = true;

Vue.component(
  "favorite-hotels-component",
  require("./components/home/FavoriteHotelsComponent.vue").default
);

Vue.component(
  "member-promotions-component",
  require("./components/home/MemberPromotionsComponent.vue").default
);
Vue.component(
  "popular-rooms-component",
  require("./components/home/PopularRoomsComponent.vue").default
);
Vue.component(
  "trendy-destinations-component",
  require("./components/home/TrendyDestinationsComponent.vue").default
);

const app = new Vue({
  el: "#vueApp",
});
